import { makeStyles } from '@material-ui/core/styles';

/**
 * Stabilize table body height: SimpleTable uses viewport-based maxHeight (100vh - …) on
 * .MuiTableContainer-root, which changes when the window is resized. LinkedTables wraps
 * the viewer and overrides max-height here only (does not modify SimpleTableViewer).
 */
const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: 0,
    },
    /** Locks scroll area to a fixed max height so resize does not grow/shrink the table region */
    tableHost: {
        width: '100%',
        minHeight: 0,
        '& .MuiTableContainer-root': {
            maxHeight: '480px !important',
            overflowY: 'auto',
        },
    },
}));

export default useStyles;
